<template>
  <v-navigation-drawer
    v-if="value"
    :value="value"
    @input="input => $emit('input', input)"
    fixed
    temporary
    right
    width="800"
  >
    <div style="min-height: 100%; overflow-y: hidden; background-color: #fdfdfd;" class="d-flex flex-column">
      <header class="pa-4 white d-flex align-center" style="font-size: 1.3em; height: 64px;">
        <v-btn icon @click="$emit('input', false)" class="mr-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Configurações de afiliado</span>
        <v-spacer></v-spacer>
        <v-btn color="light-blue" dark depressed style="width: 150px;" @click="save()" :loading="loading">Salvar</v-btn>
      </header>
      <v-divider></v-divider>
      <div class="d-flex flex-column justify-center align-center flex-grow-1 pa-4" style="overflow-y: auto;">
        <v-card flat class="pa-4 d-flex flex-column" style="width: 100%; max-width: 400px;">
          <v-subheader class="mb-2">Configure seu Pix para recebimentos</v-subheader>
          <v-text-field
            class="mt-5"
            label="Nome do titular da conta"
            placeholder=""
            v-model="form.name"
            outlined
            hide-details
          ></v-text-field>
          <v-text-field
            class="mt-5"
            label="Nome da instituição bancária"
            placeholder="Sicredi, Banco do Brasil, etc"
            v-model="form.bank_name"
            outlined
            hide-details
          ></v-text-field>
          <v-select
            class="mt-5"
            label="Tipo de chave Pix"
            placeholder="Selecione"
            v-model="form.type"
            :items="[
              'CPF/CNPJ',
              'Chave aleatória',
              'Telefone',
              'E-mail'
            ]"
            outlined
            hide-details
          ></v-select>
          <v-text-field
            class="mt-5"
            label="Chave Pix"
            placeholder="Digite"
            v-model="form.pix"
            outlined
            hide-details
          ></v-text-field>
        </v-card>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['value'],
  data () {
    return {
      loading: false,
      form: {
        type: 'CPF/CNPJ'
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  watch: {
    value: {
      immediate: true,
      handler: async function () {
        this.form = JSON.parse(JSON.stringify(this.user.bank_data || { type: 'CPF/CNPJ' }))
      }
    }
  },
  methods: {
    async save () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/update', {
          bank_data: this.form
        })

        this.$emit('input', null)
      } catch (e) {
        alert('Ops! Ocorreu algum erro ao salvar seus dados bancários. Por favor, verifique se os campos foram preenchidos corretamente.')
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>